// All JS files. 

import { initShop } from './components/shop';
import { initMobileMenu } from './header/mobile-menu';

const initAll = () => {
    initShop();
    initMobileMenu();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}